
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteVacancySectionFrom from '@/form/Settings/site/vacancy_section';

@Component({
    components: {FormGroup},
})
export default class VacancySectionCreateForm extends Vue {
    @Prop() form!:  SiteVacancySectionFrom;

    async created(): Promise<void> {
        console.log('creted');
    }
}
